import React from "react";
import OrganizationEventSubscriptionsIndexPage from "pages/_common/organization/OrganizationEventSubscriptionsIndexPage";
import { Route, Switch } from "react-router-dom";

const OrganizationEventSubscriptionsRouter = () => {
  return (
    <Switch>
      <Route
        exact
        path="/organizations/:organization_id/event_subscriptions"
        component={OrganizationEventSubscriptionsIndexPage}
      />
    </Switch>
  );
};

export default OrganizationEventSubscriptionsRouter;
